<template>
    <div class="section">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <v-col cols="12" class="text-center mb-5">
                    <h1>How Agencies Use Yabbr</h1>
                </v-col>
            </v-row>
            <v-row cols="12" justify="center">
                <v-col cols="12" md="4">
                    <v-card width="100%" class="mb-10 pa-4 fill-height d-flex align-center justify-center flex-column hover-card">
                        <v-card-text><v-icon color="primary" class="d-flex align-center">mdi-car-brake-alert</v-icon></v-card-text>
                        <v-card-title class="pt-0">
                            Emergency Alerts
                        </v-card-title>
                        <v-card-text class="text-center">Deliver fast, reliable notifications during outages, disasters, or urgent updates.
                        </v-card-text>
                        
                    </v-card>
                </v-col>
                <v-col cols="12" md="4">
                    <v-card class="mb-10 pa-4 fill-height d-flex align-center justify-center flex-column hover-card" width="100%">
                        <v-card-text><v-icon color="primary" class="d-flex align-center">mdi-human-queue</v-icon></v-card-text>
                        <v-card-title class="pt-0">
                            Citizen Engagement

                        </v-card-title>
                        <v-card-text class="text-center">Provide interactive surveys, campaigns, and web chat to better understand community needs.</v-card-text>
                        
                    </v-card>
                </v-col>
            </v-row>
            <v-row cols="12" justify="center">
                <v-col cols="12" md="4">
                    <v-card class="mb-10 pa-4 fill-height d-flex align-center justify-center flex-column hover-card" width="100%">
                        <v-card-text><v-icon color="primary" class="d-flex align-center">mdi-clock-outline</v-icon></v-card-text>
                        <v-card-title class="pt-0">
                            Automated Reminders

                        </v-card-title>
                        <v-card-text class="text-center">Send follow-ups for licenses, payments, or applications — without manual effort.</v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4">
                    <v-card class="mb-10 pa-4 fill-height d-flex align-center justify-center flex-column hover-card" width="100%">
                        <v-card-text><v-icon color="primary" class="d-flex align-center">mdi-chat</v-icon></v-card-text>
                        <v-card-title class="pt-0">
                            Secure Web Chat

                        </v-card-title>
                        <v-card-text class="text-center">Give citizens a unified channel (SMS, Email, MMS, Voice) that supports translation and routing.</v-card-text>
                        
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'GovUses',
}
</script>

<style lang="scss">


</style>